var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "证件材料",
        visible: _vm.showDialog,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [_c("div", [_vm._v("证件材料")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }